import { Game } from '@/constants/game.const';
import { cn } from '@/utils/cn';
import { CsIcon } from './icons/games/CsIcon';
import { DotaIcon } from './icons/games/DotaIcon';

export function GameIcon({
  game,
  className = 'w-4',
}: {
  game: Game | null;
  className?: string;
}): React.ReactNode | null {
  switch (game) {
    case Game.CS2:
      return (
        <CsIcon
          className={cn('text-orange', className)}
          desc="Counter-Strike 2 game icon"
          title="Counter-Strike 2"
        />
      );
    case Game.DOTA:
      return (
        <DotaIcon
          className={cn('text-red', className)}
          desc="Dota 2 game icon"
          title="Dota 2"
        />
      );
    case null:
      return null;
    default:
      game satisfies never;
      return null;
  }
}
